import { CssUnit } from '@/types'

const toString = (v?: CssUnit): string => (typeof v !== 'string' ? `${v}` : v)

export const toUnit = (v?: CssUnit) => {
  const val = toString(v)
  if (!v) return v
  return /^(-?[0-9]+\.?[0-9]*(px|em|rem|fr|%)|auto|unset|max-content)/.test(val) ? val : `${val}px`
}
